var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconQualityControl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-qualityControl"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-qualityControl",
    clipPath: "url(#clip-icon-qualityControl)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M237.863,216l-.229-.229.013-.013C237.723,215.836,237.787,215.925,237.863,216Z",
    fill: "none",
    stroke: "#5bac5a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M924.16,180.269h-477.6C430.573,115.15,371.688,66.7,301.7,66.7S172.82,115.15,156.83,180.269H99.84a35.618,35.618,0,1,0,0,71.237h56.99c16,65.119,74.889,113.56,144.867,113.56s128.876-48.441,144.866-113.56h477.6a35.618,35.618,0,1,0,0-71.237ZM371.013,251.506a77.911,77.911,0,1,1,8.625-35.619A78.009,78.009,0,0,1,371.013,251.506Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M237.863,216l-.229-.229.013-.013C237.723,215.836,237.787,215.925,237.863,216Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M924.16,476.388H859.117c-15.99-65.119-74.875-113.573-144.866-113.573S585.362,411.269,569.372,476.388H99.84a35.618,35.618,0,1,0,0,71.237H569.372c16,65.119,74.888,113.56,144.879,113.56s128.863-48.441,144.866-113.56H924.16a35.618,35.618,0,1,0,0-71.237ZM783.568,547.625a77.915,77.915,0,1,1,8.624-35.619A78.039,78.039,0,0,1,783.568,547.625Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M924.16,772.507h-477.6c-15.99-65.119-74.875-113.561-144.866-113.561S172.833,707.388,156.83,772.507H99.84a35.618,35.618,0,1,0,0,71.237h56.99c16,65.119,74.889,113.56,144.867,113.56s128.876-48.441,144.866-113.56h477.6a35.618,35.618,0,1,0,0-71.237ZM371.013,843.744a77.859,77.859,0,1,1,8.625-35.619A78.009,78.009,0,0,1,371.013,843.744Z",
    fill: "currentColor"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQualityControl);
export default __webpack_public_path__ + "static/media/icon-qualityControl.0e66573962a1b6353787c1cb375a6288.svg";
export { ForwardRef as ReactComponent };